import { Component, Vue, Prop } from 'vue-property-decorator'
import http from '@/services/http'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class HeaderSettings extends Vue {
  @Prop({ required: true })
  txtTittle!: string
  @Prop({ required: true })
  txtLabel!: string
  @Prop({ required: true })
  txtPlaceholder!: string

  @Prop({ required: true })
  objCreate!: any

  @Prop({ required: true })
  route!: any

  @Prop({ required: true })
  item!: any

  showForm = false

  loading = false

  search = ''

  enter = 'residency_status'

  async createObj() {
    try {
      await http.post(`api/${this.route}`, this.objCreate)
      this.$buefy.toast.open({
        message: 'Agregado',
        type: 'is-success',
      })
      setTimeout(() => {
        this.loading = false
        this.close()
      }, 1000)
    } catch (error) {
      console.error(error)
      this.loading = false
      this.$buefy.toast.open({
        message: `Ups!, ha ocurrido un error`,
        type: 'is-danger',
      })
    }
  }
  filterItems() {
    this.$emit('searchData', this.search)
  }
  openCollapse() {
    this.showForm = true
    this.$emit('openCollapse')
  }
  close() {
    this.showForm = false
    this.$emit('closeCollapse')
  }
}
